// this is an autogenerated file from DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Address/Addresses/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_DataVaxiomOtherProfessionalsEdit_Content_Address_Addresses($person_id: numeric!) {
  vaxiom_contact_method_associations(
    where: {
      person_id: { _eq: $person_id }
      contact_method: { dtype: { _eq: "postal" } }
    }
    order_by: { id: asc }
  ) {
    id
    preference
    contact_method_id
    description
    postal_address {
      id
      address_line1
      city
      state
      zip
    }
  }
}

`